<template>
	<div class="card">
		<div class="card-header" style="height:45px">
	      <div>
	          <div class="d-flex mb-3">
	              <div>
	                  <el-switch
                      v-if="userRole == 2"
                      v-model="type"
                      :active-text="$t('dashboard.personal.team')"
                      :inactive-text="$t('dashboard.personal.my')">
                    </el-switch>
                    <el-cascader
                        v-if="userRole == 1"
                        size="mini"
                        expand-trigger="hover"
                        :options="practice"
                        :props="optionProps"
                        v-model="practiceId"
                        style="width:100%"
                        :clearable="true">
                    </el-cascader>
	              </div>
	              <span class="flex"></span>
	              <div>
	                  <el-radio-group v-model="tab" size="mini">
					      <el-radio-button :label="$t('dashboard.personal.month')"></el-radio-button>
					      <el-radio-button :label="$t('dashboard.personal.quarter')"></el-radio-button>
					      <el-radio-button :label="$t('dashboard.personal.year')"></el-radio-button>
					  </el-radio-group>
	              </div>
	          </div>
	      </div>
		</div>
		<div class="card-body">
			<div class="row row-sm">
                <div class="col-11 col-sm-9">
                    <div class="mb-2">
                        <small class="text-muted">{{ $t('dashboard.personal.performance-overview') }}</small>
                    </div>
                    <el-row>
                        <el-col :span="5">
                            <div class="text-highlight text-md">{{ po[tab].offerValue.toFixed(1) }}</div>
                            <small>{{ $t('dashboard.personal.offer-value') }}</small>
                        </el-col>
                        <el-col :span="4">
                            <div class="text-danger text-md">{{ po[tab].offerNo }}</div>
                            <small>{{ $t('dashboard.personal.offer-no') }}</small>
                        </el-col>
                        <el-col :span="5">
                            <div class="text-md">{{ po[tab].invoicedValue.toFixed(1) }}</div>
                            <small>{{ $t('dashboard.personal.invoiced-value') }}</small>
                        </el-col>
                        <el-col :span="4">
                            <div class="text-md">{{ po[tab].cashin.toFixed(1) }}</div>
                            <small>{{ $t('dashboard.personal.cashin') }}</small>
                        </el-col>
                        <el-col :span="6">
                            <div class="text-md">{{ po[tab].ar.toFixed(1) }}</div>
                            <small>{{ $t('dashboard.personal.ar') }}</small>
                        </el-col>
                        
                    </el-row>
                </div>
                <div class="col-1 col-sm-3">
                    
                    <div>{{ $t('dashboard.personal.cr') }}</div>
                    <div>
                        <Chart id="personal-overview" :options="options" style="height: 110px" />
                    </div>
                </div>
            </div>
		</div>
	</div>
</template>
<style>
.hide {
  display: none;
  visibility: hidden;
}
.chart-wrapper {
  height: 130px;
}
</style>
<script>
// @ is an alias to /src
import Chart from '@/components/dashboard/Chart.vue'
import moment from 'moment'

export default {
  name: 'Personal-Overview',
  components: {
    Chart
  },
  data: function() {
    return {
      tab: "Month",
      type: "Personal",
  	  options: null,
      practiceId: null,
  	  currentYear: moment().year(),
      data: null,
      optionProps: {
        value: 'id',
        label: this.$i18n.locale === 'zh' ? 'c_name' : 'e_name',
        children: 'sub_category'
      },
      po: {
  	    "Month": {
  	        "ar": 0.0, 
  	        "cashin": 0.0, 
  	        "cr": 0.0, 
  	        "invoicedValue": 0.0, 
  	        "offerNo": 0, 
  	        "offerValue": 0.0, 
  	        "target": 0.0
  	    }, 
  	    "Quarter": {
  	        "ar": 0.0, 
  	        "cashin": 0.0, 
  	        "cr": 0.0, 
  	        "invoicedValue": 0.0, 
  	        "offerNo": 0, 
  	        "offerValue": 0.0, 
  	        "target": 0.0
  	    }, 
  	    "Year": {
  	        "ar": 0.0, 
  	        "cashin": 0.0, 
  	        "cr": 0.0, 
  	        "invoicedValue": 0.0, 
  	        "offerNo": 0, 
  	        "offerValue": 0.0, 
  	        "target": 0.0
  	    }
  	  }
  	}
  },
  computed: {
    userRole: function() {
      return localStorage.getItem('role')
    },
    userId: function() {
      return localStorage.getItem('userId')
    }
  },
  watch: {
    "tab": function(val) {
      this.setChart()
    },
    "type": function(val) {
      this.setChart()
    }
  },
  methods: {
    setChart: function() {
      let that = this
      this.options = {
        title: {
	        text: '',
	        left: 'center',
	        top: 40,
	        textStyle: {
	        	color: '#1890FE'
	        }
	    },
	    legend: {
	    	show: false
	    },
        label: {
        	show: false
        },
        series: [{
            type: 'pie',
            radius: ['55%', '70%'],
            center: ['50%', '50%'],
            labelLine: {
                show: false
            },
            data : [
                
            ]
        }]
      }
      this.data.then(function (response) {
        if (that.type == 'Personal')
          that.po = response.personal
        else
          that.po = response.team
        let cr = parseFloat(that.po[that.tab].cr)
        that.options.title.text = cr.toFixed(1) + '%'
        that.options.series[0].data = []
        that.options.series[0].data.push({
        	value : 100 - cr,
        	itemStyle : { color: '#eeeeee' }
        })
        that.options.series[0].data.push({
        	value : cr,
        	itemStyle : { color: '#2490EF' }
        })
        console.log(that.options)
        
      })
	  
    },
    async loadData () {
      try {
        let query = '?userId=' + localStorage.getItem('token'),
            res = await this.$http.get(this.API_PREFIX + 'personal_overview' + query)
        return res.data
      } catch (err) {
        console.log(err)
      }
    }
  },
  created: function() {
    this.currentYear = moment().year()
    if (this.userId == 1) 
      this.type = 'Team'
    this.data = this.loadData()
    //console.log(this.data)
  },
  mounted: function() {
    this.setChart()
  }
}
</script>